import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=5c220e96&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=js"
export * from "./Trades.vue?vue&type=script&lang=js"
import style0 from "./Trades.vue?vue&type=style&index=0&id=5c220e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c220e96",
  null
  
)

export default component.exports